<div>
    <h5 class="rps-heading-five" id="minimums" tabindex="-1">Minimums</h5>
    <table *ngIf="minimums || minimum; else noTableData" style= "width: 100%" aria-label="Fund minimums">
        <tr class="minimums-header">
            <th scope="col" style="text-align:left; width: 50%;">{{is529? 'Accounts': ''}}</th>
            <th Class="initial-min Add-min" scope="col" *ngIf="!is529">Initial minimum</th>
            <th scope="col" *ngIf="is529">Initial minimum</th>
            <th Class="Add-min" scope="col" *ngIf="!is529">Additional investments</th>
        </tr>

        <tr class="minimums-data" *ngIf="is529">
            <td scope="col" style="text-align:left" data-rpa-tag-id="accounts">529 Plan</td>
            <td scope="col" data-rpa-tag-id="minInvestment">{{minimum | currency:'USD':'symbol-narrow':'1.0-0' |
                DashIfEmpty}} Per account</td>
        </tr>

        <tr class="minimums-data" *ngIf="!is529 && minimums && minimums.general && minimums.general.name">
            <td scope="col" style="text-align:left" data-rpa-tag-id="accounts">General account</td>
            <td Class="initial-min" scope="col" data-rpa-tag-id="minInvestment">{{isNumber(minimums.general.initial) ?
                (minimums.general.initial | currency:'USD':'symbol-narrow':'1.0-0') : minimums.general.initial}}</td>
            <td class="additional-inv" scope="col" data-rpa-tag-id="minInvestment">{{isNumber(minimums.general.additional) ?
                (minimums.general.additional | currency:'USD':'symbol-narrow':'1.0-0') : minimums.general.additional}}
            </td>
        </tr>

        <tr class="minimums-data" *ngIf="!is529 && minimums && minimums.ugma && minimums.ugma.name">
            <td scope="col" style="text-align:left" data-rpa-tag-id="accounts">{{minimums.ugma.name}}</td>
            <td Class="initial-min" scope="col" data-rpa-tag-id="minInvestment">{{isNumber(minimums.ugma.initial) ? (minimums.ugma.initial |
                currency:'USD':'symbol-narrow':'1.0-0') : minimums.ugma.initial}}</td>
            <td class="additional-inv" scope="col" data-rpa-tag-id="minInvestment">{{isNumber(minimums.ugma.additional) ?
                (minimums.ugma.additional | currency:'USD':'symbol-narrow':'1.0-0') : minimums.ugma.additional}}</td>
        </tr>

        <tr class="minimums-data" *ngIf="!is529 && minimums && minimums.ira && minimums.ira.name">
            <td scope="col" style="text-align:left" data-rpa-tag-id="accounts">{{minimums.ira.name}}</td>
            <td Class="initial-min" scope="col" data-rpa-tag-id="minInvestment">{{isNumber(minimums.ira.initial) ? (minimums.ira.initial |
                currency:'USD':'symbol-narrow':'1.0-0') : minimums.ira.initial}}</td>
            <td class="additional-inv" scope="col" data-rpa-tag-id="minInvestment">{{isNumber(minimums.ira.additional) ?
                (minimums.ira.additional | currency:'USD':'symbol-narrow':'1.0-0'): minimums.ira.additional}}</td>
        </tr>
    </table>
    <ng-template #noTableData>
        <p class="no-data">This information is temporarily unavailable.</p>
    </ng-template>
</div>
